/**
 * Smooth-scrolls clicks on same-page anchors (href="#some-id").
 *
 * Delegated from the document, so links added after load — AJAX content, popup
 * markup, Gravity Forms confirmations — work without rebinding.
 *
 * Links carrying a `data-toggle` attribute are left alone, as are the popup
 * triggers handled by assets/popups/pp-popups.js.
 */
const AnimateOnPageLinks = {

    offset: -100,

    init() {

        document.addEventListener('click', (e) => {

            const link = e.target.closest('a[href^="#"]');

            if (!link || this.is_excluded(link)) {
                return;
            }

            const href = link.getAttribute('href');

            if (href === '#' || href.startsWith('#popup-')) {
                return;
            }

            let target;

            try {
                target = document.querySelector(href);
            } catch (err) {
                return; // not a usable selector
            }

            if (!target) {
                return;
            }

            e.preventDefault();

            const offset = target.dataset.scrollToOffset === undefined
                ? this.offset
                : parseInt(target.dataset.scrollToOffset, 10);

            const top = target.getBoundingClientRect().top + window.pageYOffset + offset;
            const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

            window.scrollTo({ top, behavior: reduced ? 'auto' : 'smooth' });

            target.dispatchEvent(new CustomEvent('scrolled_to', { bubbles: true }));
        });

    },

    is_excluded(link) {
        return link.dataset.toggle !== undefined || link.hasAttribute('data-pp-popup');
    }

};

export default AnimateOnPageLinks;
